import { Component, OnInit, inject, input } from '@angular/core';
import { Router } from '@angular/router';
import { MovementNoPurchaseService } from '../../../service/movement-no-purchase.service';
import { UserLoginService } from '../../../service/user-login.service';

@Component({
  selector: 'app-movement-no-purchase-comments',
  templateUrl: './movement-no-purchase-comments.component.html',
  styleUrls: ['./movement-no-purchase-comments.component.scss'],
  standalone: false,
})
export class MovementNoPurchaseCommentsComponent implements OnInit {
  router = inject(Router);
  userService = inject(UserLoginService);
  mnpService = inject(MovementNoPurchaseService);

  readonly eventId = input<string>(undefined);
  readonly comments = input<string>(undefined);

  content: string = '';
  isEditing = false;
  isUpdating = false;

  ngOnInit(): void {
    this.content = this.comments() || '';
    if (!this.content) this.isEditing = true;
  }

  onInputKeyUp(event) {
    this.content = event.target.value;
  }

  onCancelComment() {
    this.isEditing = false;
  }

  onUpdateComment() {
    this.isUpdating = true;
    this.mnpService.updateComment(this.eventId(), this.content).subscribe(
      () => {},
      this.handleDataForbidden,
      () => {
        this.isUpdating = false;
        this.isEditing = false;
      },
    );
  }

  handleDataForbidden(error) {
    if (error.status === 403) {
      try {
        this.router.navigate(['/403']);
      } catch (e) {
        console.error(e);
      }
    }
  }
}
